import { type FeatureFlagList } from './types';

/**
 * Feature flag defaults
 */
export const defaultFeatureFlags: FeatureFlagList = {
	'platform-component-visual-refresh': true,
	'platform-visual-refresh-icons': true,
	'navx-full-height-sidebar': false,
	'platform-dst-lozenge-tag-badge-visual-uplifts': false,
	'platform-dst-shape-theme-default': true,
};
